import React from 'react';

const GeneratedSteps = ({ 
  steps, 
  showGeneratedSteps, 
  onAccept, 
  onReject 
}) => {
  if (!showGeneratedSteps || steps.length === 0) {
    return null;
  }

  return (
    <div className="border border-green-100 rounded-lg mb-4">
      <div className="bg-green-50 px-4 py-2 rounded-t-lg border-b border-green-100 flex justify-between items-center">
        <div className="flex items-center gap-2">
          <h3 className="text-sm font-medium text-gray-900">AI Generated Steps</h3>
          <span className="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded">Pending</span>
        </div>
      </div>
      <div className="p-4">
        {steps.map((step, index) => (
          <div key={index} className="py-2 flex items-center text-sm text-gray-600">
            <span className="mr-2">{index + 1}.</span>
            <span>
              {step.action === 'type' 
                ? `Type Text ${step.value} (${step.element})`
                : `Click on ${step.element} (button)`}
            </span>
          </div>
        ))}
        <div className="flex justify-end gap-2 mt-4">
          <button
            onClick={onReject}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none"
          >
            ✕ Reject
          </button>
          <button
            onClick={onAccept}
            className="px-4 py-2 text-sm font-medium text-white bg-black rounded-md hover:bg-gray-800 focus:outline-none"
          >
            ✓ Accept Steps
          </button>
        </div>
      </div>
    </div>
  );
};

export default GeneratedSteps; 